import { render, staticRenderFns } from "./AdsenseAdvertisementDisclosure.vue?vue&type=template&id=6dfa672f&scoped=true"
import script from "./AdsenseAdvertisementDisclosure.vue?vue&type=script&lang=js"
export * from "./AdsenseAdvertisementDisclosure.vue?vue&type=script&lang=js"
import style0 from "./AdsenseAdvertisementDisclosure.vue?vue&type=style&index=0&id=6dfa672f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfa672f",
  null
  
)

export default component.exports